import { render, staticRenderFns } from "./ChangePassword.html?vue&type=template&id=14bd99a6&"
import script from "./ChangePassword.js?vue&type=script&lang=js&"
export * from "./ChangePassword.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports